import { Component, OnDestroy, OnInit } from '@angular/core';
import {  claimTypes } from '../environments/environment';

import {
  ExtUser,
  SharedDataService
} from 'ngx-paf-common';
import {  SubscriptionLike } from 'rxjs';
import { AuthenticationService } from './SERVICES/authentication.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'paf-extranet';

  subs : SubscriptionLike[] = [];
  public loggedUserInfo?: ExtUser;
  public claimTypes = claimTypes;

  constructor(
    private authSvc: AuthenticationService,
    public sharedDataSvc: SharedDataService,
  ) { }
  
  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

 async ngOnInit() {
    const extUserChangeSub = this.sharedDataSvc.loggedExtUserChange
      .subscribe({
        next:async (user: ExtUser) => {
          this.loggedUserInfo = user;
          if (user) {
            // pour activer la trace de connexion dans le backend, on doit fournir un token d'authentification valide dans les headers de chaque requete.
            this.sharedDataSvc.authToken = this.authSvc.getAccessToken();
          }
        }
      });
    this.subs.push(extUserChangeSub);
    await this.authSvc.loadDiscoveryDocument();
    this.authSvc.UpdateGlobalClaims();
 }



  public get urlEndingWithSupplierId():string{
    const regex = new RegExp("(?<=supplier-details/)[0-9]+$", 'g');
    let matches: any=regex.exec(window.location.href);
    return (matches ? <string>matches[0]: null);
  }
  
}
